export const BASE_URL_PROD = 'https://www.fairview-rewards.com';

export const BASE_SECTION_CODES = {
  DEMOGRAPHIC: '0001',
  INTERESTS: '0206',
};

export const SECTION_CODES = {
  AGE_RANGE: '0001#0002',
  GENDER: '0001#0048',
  EMPLOYMENT_STATUS: '0001#0016#0039',
  RESIDENCE_LENGTH: '0001#0053#0073',
  COUNTRY: '0001#0053#0054#0055',
  CITY: '0001#0053#0054#0057',
  POST_CODE: '0001#0053#0054#0059',
  EDUCATION: '0001#0016#0017',
  LIFE_STAGE: '0001#0053#0093',
  BUSINESS_AND_FINANCE: '0206#0268',
  HEALTHY_LIVING: '0206#0406',
  SPORTS: '0206#0607',
  TECHNOLOGY_COMPUTING: '0206#0687',
  TEST_ACCOUNT: '9999',
};

export const FIREBASE_ERRORS = {
  WRONG_PASS: 'auth/wrong-password',
  USER_NOT_FOUND: 'auth/user-not-found',
};

export const EXTENSION = {
  CHROME: 'https://chrome.google.com/webstore/detail/dnaneacljgfehfmpeklnpionjianaiie',
  FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/fairview-sidebar/',
  MICROSOFT_EDGE:
    'https://microsoftedge.microsoft.com/addons/detail/fairview-sidebar/jkjnoalbigeokhjnimbnkogjpmapildk',
};

export const PDF = {
  PRIVACY_POLICY: 'https://fairview-rewards.com/files/PrivacyPolicy.pdf',
  COOKIE_POLICY: 'https://fairview-rewards.com/files/CookiePolicy.pdf',
  TERM: 'https://fairview-rewards.com/files/TermOfService.pdf',
};

export const URLS = {
  EMAIL_PREFERENCES: 'https://www.fairview-rewards.com/emailPreferencesForm.html',
};

export const COUNTRIES = {
  UK: {
    countryName: 'United Kingdom',
    geonameId: 2635167,
  },
};

export const SIGN_UP_METHODS = {
  EMAIL: 'email',
  GOOGLE: 'Google',
  FACEBOOK: 'Facebook',
};
